<div *ngIf="currentStep === -1" class="walkthrough-first-container">
  <div class="walkthrough-header">
    <a class="walkthrough-exit" (click)="closeDialog()">{{ 'about.me.walkthrough.skip.label' | translate }}</a>
  </div>
  <div class="walkthrough-content">
      <app-svg styleClass="h-[44px] w-[44px] rounded-lg" href="/assets/svg/menu/logo.svg" />
    <h1 class="walkthrough-title">{{ 'about.me.walkthrough.welcome.label' | translate }}</h1>
    <p class="walkthrough-description">
      {{ 'about.me.walkthrough.description.label' | translate }}
    </p>
    <button class="walkthrough-start-btn" (click)="nextStep(null)">
      {{ 'about.me.walkthrough.start.label' | translate }}
    </button>
  </div>
</div>

<div *ngIf="currentStep >= 0 && !isLastStep" class="walkthrough-question-container">
  <app-about-me-question
    [answer]="questions[currentStep].answer"
    [question]="questions[currentStep]"
    [currentStep]="currentStep"
    [totalSteps]="questions.length"
    (onNext)="nextStep($event)"
    (onPrev)="previousStep()"
    (onSaveAndExit)="closeDialog()"
  />
</div>

<div *ngIf="currentStep >= 0 && isLastStep" class="walkthrough-last-container">
  <div class="walkthrough-content">
    <div class="walkthrough-last-icon">
      <img src="assets/svg/like.svg" alt="Success Icon" />
    </div>
    <h1 class="walkthrough-title">{{ 'about.me.walkthrough.completed.title.label' | translate }}</h1>
    <p class="walkthrough-description">{{ 'about.me.walkthrough.completed.description.label' | translate }}</p>
    <button class="walkthrough-start-btn" (click)="closeDialog()">
      {{ 'about.me.walkthrough.back.home.label' | translate }}
    </button>
  </div>
</div>
